import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const TransactionNavUI = ({account, page}) =>
  <div className='g_flex_h g_flex_left g_flex_wrap g_m_bottom_50'>
    <TabLinkUI label='Cash Flow' to={`/su/accounts/${account.accountId}/cashFlow2`} active={page === 'cashFlow2'} />
    <TabLinkUI label='Cash Flow (Alt)' to={`/su/accounts/${account.accountId}/cashFlow`} active={page === 'cashFlow'} />
  </div>

export default TransactionNavUI
